import React, { useEffect, useState } from "react";
import "../../../index.scss";
import "./ServiceListPage.scss";
import { getServicesOfOrganization } from "../../../services/utilsService/utilsService";
import SearchBar from "../../../components/searchBar/searchBar";
import ServiceCard from "../../../components/supervisor/ServiceCard/ServiceCard";
import ChipsArray from "../../../components/supervisor/ChipsArray/ChipsArray";

import LinearProgress from "@mui/material/LinearProgress";
import InternetErrorComponent from "../../../components/Errors/InternetErrorComponent";


const ServiceListPage = () => {
  //Services
  const [inputProduct, setInputProduct] = useState("");
  const [serviceListDefault, setServiceListDefault] = useState([]);
  const [serviceList, setServiceList] = useState([]);

  //Categories - service menu
  const [categoriesList, setCategoriesList] = useState([]);
  const [categoriesOn, setCategoriesOn] = useState([]);

  //All Services
  const [allServices, setAllProducts] = useState([]);

  //Set loading
  const [loading, setLoading] = useState(true);

  const [tableLoading, setTableLoading] = useState(true);

  const [tableLoadingError, setTableLoadingError] = useState(false);

  const [specialPricesOn, setSpecialPricesOn] = useState(false);


  const fetchData = async () => {
    setTableLoading(true);
    getServicesOfOrganization()
      .then((data) => {
        // console.log(data, "products");
        let bigCategories = data["service_categories"];
        // console.log(bigCategories, "bigCategories");

        bigCategories.forEach(cat => {
          // console.log(cat.name, "products:", cat.products);
        });

        let categories = bigCategories.map((cat, index) => ({
          key: index,
          label: cat.name,
          active: false,
        }));

        let serviceArray = [];
        for (let i = 0; i < bigCategories.length; i++) {
          const element = bigCategories[i]["products"];
          for (let j = 0; j < element.length; j++) {
            const element2 = element[j];
            serviceArray.push(element2);
          }
        }
        setServiceListDefault(serviceArray);
        // console.log("serviceArray final:", serviceArray);
        setServiceList(serviceArray);

        const prevPage = sessionStorage.getItem("prevPage");

        if(prevPage !== "ServiceForm") {
          sessionStorage.removeItem('selectedCategories');
          sessionStorage.removeItem('prevPage');
        }

        sessionStorage.setItem("prevPage", "products");

        const activeCategories = [];

        const savedCategories = sessionStorage.getItem('selectedCategories');
        if (savedCategories) {
          const parsedCategories = JSON.parse(savedCategories);
          
          // update chips visual state
          const updatedCategories = categories.map(cat => {
            // check if this category is in the saved categories
            const isActive = parsedCategories.some(saved => saved.key === cat.key);
            if (isActive) {
              activeCategories.push({...cat, active: false});
            }
            return {...cat, active: isActive};
          });
          setCategoriesList(updatedCategories);
          setCategoriesOn(activeCategories);
        } else {
          setCategoriesList(categories);
        }

        setAllProducts(bigCategories);
        
        if(activeCategories.length > 0) {
          let serviceArrayFiltered = [];
          for (let i = 0; i < activeCategories.length; i++) {
            const index = activeCategories[i]['key'];
            const element = bigCategories[index]["products"];

            for (let j = 0; j < element.length; j++) {
              const element2 = element[j];
              serviceArrayFiltered.push(element2);
            }
          }

          setServiceList(serviceArrayFiltered);
        } else {
          setServiceList(serviceArray);
        }

        setLoading(false);
        setTableLoading(false);
      })
      .catch((error) => {
        setTableLoadingError(true);
        setTableLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);


  const updateInputProducts = async (input) => {
    const filtered = serviceListDefault.filter((service) => {
      if (service.barcode) {
        return (
          service.name.toLowerCase().includes(input.toLowerCase()) ||
          service.barcode.toLowerCase().includes(input.toLowerCase())
        );
      } else {
        return service.name.toLowerCase().includes(input.toLowerCase());
      }
    });
    setInputProduct(input);
    setServiceList(filtered);
  };


  const updateChipsProducts = async (dataChip) => {
    let categorias = [...categoriesOn]; 
    let updatedCategoriesList = [...categoriesList]; 
    
      // check if the chip is already selected
    const chipIndex = categorias.findIndex(cat => cat.key === dataChip.key);
    
    if (chipIndex !== -1) {
      // remove the category if it is already selected
      categorias.splice(chipIndex, 1);
      // update visual state
      updatedCategoriesList = updatedCategoriesList.map(cat => 
        cat.key === dataChip.key ? {...cat, active: false} : cat
      );
    } else {
      // add the category if it is not selected
      categorias.push(dataChip);
      // update visual state
      updatedCategoriesList = updatedCategoriesList.map(cat => 
        cat.key === dataChip.key ? {...cat, active: true} : cat
      );
    }
    
    setCategoriesOn(categorias);
    setCategoriesList(updatedCategoriesList);
    sessionStorage.setItem('selectedCategories', JSON.stringify(categorias));
    searchProductsOfCategories(categorias);
  };


  function searchProductsOfCategories(categories) {
    let indexCat = categories.map((item) => item.key);
    let fullProductsByFilter = [];
    for (let i = 0; i < indexCat.length; i++) {
      const index = indexCat[i];
      let servicesInCat = allServices[index]["products"];
      for (let j = 0; j < servicesInCat.length; j++) {
        const service = servicesInCat[j];
        fullProductsByFilter.push(service);
      }
    }
    if (fullProductsByFilter.length === 0) {
      fullProductsByFilter = serviceListDefault;
    }

    setServiceList(fullProductsByFilter);
  }

  // ----------------------------------------------------
  // ------------------ Ingredients ---------------------
  // ----------------------------------------------------

  return (
    <article className="row">
      {tableLoadingError ? (
        <InternetErrorComponent></InternetErrorComponent>
      ) : (
        <>
          {serviceListDefault && (
            <div className="row align-items-start">
              <div class="col-12">
                <SearchBar
                  input={inputProduct}
                  onChange={updateInputProducts}
                  nombre="Servicio"
                />
              </div>
            </div>
          )}
          {tableLoading && <LinearProgress className="custom-linear-progress" />}
          {!tableLoading && !tableLoadingError && categoriesList && (
            <ChipsArray
              chipsData={categoriesList}
              chipManage={updateChipsProducts}
            ></ChipsArray>
          )}
          {/* {tableLoadingError && (
        <InternetErrorComponent></InternetErrorComponent>
      )
        
      } */}
      

      <div className="products-container">
            {serviceList &&
              serviceList.map((service, i) => (
                <ServiceCard service={service} key={i}></ServiceCard>
              ))}
          </div>
        </>
      )}
    </article>
  );
};

export default ServiceListPage;
